<template>
    <div>
        <b-row>
            <b-col cols="12">
                <div class="animated fadeIn">
                    <b-row>
                        <b-col sm="12">
                            <div class="table-responsive-md">
                                <Vuetable
                                        class="table table-striped table-bordered nowrap vue-tbl"
                                        ref="usertable"
                                        :api-url="getUrl"
                                        :http-options="httpOptions"
                                        :fields="fields"
                                        pagination-path
                                        @vuetable:pagination-data="onPaginationData"
                                        :append-params="moreParams"
                                        :per-page="perPage">
                                    <template slot="actions" scope="props">
                                        <div class="custom-actions">
                                            <b-button
                                                    class="btn btn-primary btn-sm"
                                                    @click="onActionClicked('view-item', props.rowData, props.rowIndex)"
                                            >
                                               View Properties
                                            </b-button>
                                        </div>
                                    </template>
                                </vuetable>

                                <b-row>
                                    <b-col>
                                          <div class="vuetable-pagination ui basic segment grid row">
                        <b-col cols="4">
                          <vuetable-pagination-info
                            ref="paginationInfo"
                          ></vuetable-pagination-info>
                        </b-col>
                        <b-col cols="8">
                          <vuetable-pagination
                            style="float:right;"
                            ref="pagination"
                            @vuetable-pagination:change-page="onChangePage"
                          ></vuetable-pagination>
                        </b-col>
                      </div>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
        </b-row>


        <b-modal id="modal-policy-view" size="xl" centered title="View Properties">
            <hr>
            <b-row>
                <b-col class="col-md-12 property-tab">
                    {{properties_string}}
                </b-col>
            </b-row>

            <hr>
            <!-- Create -->
            <b-row class="row-top row-bottom">
                <b-col cols="8">
                    <span class="span"></span>
                </b-col>
                <b-col cols="2">
                    <span class="span"></span>
                </b-col>

                <b-col cols="2">
                    <b-button
                            block
                            variant="danger"
                            @click="cancelPolicyModal('modal-policy-view')"
                            size="md"
                    >Close</b-button
                    >
                </b-col>
            </b-row>

        </b-modal>


    </div>
</template>

<script>
    import Vue from "vue";
    import Vuetable from "vuetable-2/src/components/Vuetable";
    import VuetablePagination from "@/components/vuetable/VuetablePaginationBootstrap4";
    import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";

    export default {
        name: 'tables1',
        components: {
            Vuetable,
            VuetablePagination,
            VuetablePaginationInfo
        },
        data(){
            return {
                properties_string : '',
                httpOptions: {
                    headers: {
                        "Content-Type": "application/json;charset=UTF-8",
                        Accept: "application/json",
                        Authorization: "Bearer " + localStorage.getItem("access_token")
                    },
                    data: {}
                },
                moreParams: {},
                getUrl: process.env.VUE_APP_API_ENDPOINT + "history/activity_datatable",
                fields: [
                    {
                        name: "id",
                        title: '<span class="orange glyphicon glyphicon-user"></span> #',
                        sortField: "id",
                        width: '200px',
                    },
                    // {
                    //     name: "log_name",
                    //     title: '<span class="orange glyphicon glyphicon-user"></span> Log Name',
                    //     sortField: "log_name",
                    //     width: '200px',
                    // },
                    {
                        name: "description",
                        title: '<span class="orange glyphicon glyphicon-user"></span> Description',
                        sortField: "description",
                        width: '200px',
                    },
                    {
                        name: "subject_type",
                        title: '<span class="orange glyphicon glyphicon-user"></span> Subject Type',
                        sortField: "subject_type",
                        width: '200px',
                    },
                    {
                        name: "properties",
                        title: '<span class="orange glyphicon glyphicon-user"></span> Properties',
                        sortField: "properties",
                        width: '200px',
                        visible:false
                    },

                    {
                        name: "created_at",
                        title: '<span class="orange glyphicon glyphicon-user"></span> Created At',
                        sortField: "created_at",
                        width: '200px'
                    },
                    {
                        name: "causer",
                        title: '<span class="orange glyphicon glyphicon-user"></span> Causer Name',
                        sortField: "causer_name",
                        callback: 'getCauser',
                        width: '200px',
                    },
                    {
                        name: "__slot:actions",
                        title: '<span class="orange glyphicon glyphicon-user"></span> Action'
                    }

                ],
                data: [],
                perPage: 10,
                sortOrder: [],
                filterText: ""
            }
        },
        methods:{
            cancelPolicyModal(modalId) {
                this.$bvModal.hide(modalId);
            },
            onPaginationData(paginationData) {
                this.$refs.pagination.setPaginationData(paginationData);
                this.$refs.paginationInfo.setPaginationData(paginationData);
            },
            onChangePage(page) {
                this.$refs.usertable.changePage(page);
            },
            onFilterSet(filters) {
                this.moreParams = {
                    causer_name: filters.causer_name
                };
                Vue.nextTick(() => this.$refs.usertable.refresh());
            },
            onFilterReset() {
                this.moreParams = {};
                Vue.nextTick(() => this.$refs.usertable.refresh());
            },
            getCauser(causer){
                if(causer){
                    return causer.full_name;
                }else{
                    return  'N/A';
                }
            },
            onActionClicked(action, data, rowIndex, pdf = false) {
                if(action == 'view-item'){
                    this.properties_string = data.properties;
                    this.$bvModal.show("modal-policy-view");
                }
            },
            activeStatus(val){
                return val ? "<span class='badge badge-success'>Active</span>" : "<span class='badge badge-success'>Inactive</span>";
            },
        },
        watch: {
            data(newVal, oldVal) {
                this.$refs.usertable.refresh();
            }
        },

        mounted() {
            this.$events.$on("filter-set", eventData => this.onFilterSet(eventData));
            this.$events.$on("filter-reset", e => this.onFilterReset());
        },
    }
</script>

<style scoped>

    .card-body >>> table > tbody > tr > td {
        cursor: pointer;
    }

    .property-max-width{
        max-width: 200px !important;
    }

    .property-tab{
        overflow: auto;
        max-height: 500px;
    }


</style>